/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="13.84"
        viewBox="0 0 18 13.84"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M6.39 2.1H0v11.74h18V2.1h-6.4V0H6.39Zm-3.2 10.81H.96V3.03h2.23Zm11.62-9.88h2.25v9.88h-2.25Zm-.94 0v9.88H4.13V3.03ZM7.35.93h3.32V2.1H7.35Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BriefcaseIcon';

export default Icon;
